import React, { Component } from "react";
import PropTypes from "prop-types";
import SearchIcon from "@material-ui/icons/Search";
import { fade } from "@material-ui/core/styles/colorManipulator";
import FileIcon from "@material-ui/icons/InsertDriveFile";
import ShareIcon from "@material-ui/icons/Share";
import { connect } from "react-redux";

import {
    Fade,
    InputBase,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Paper,
    Popper,
    Typography,
    withStyles,
} from "@material-ui/core";
import { withRouter } from "react-router";
import pathHelper from "../../utils/page";
import { configure, HotKeys } from "react-hotkeys";
import { searchMyFile } from "../../redux/explorer";
import FolderIcon from "@material-ui/icons/Folder";
import { Trans, withTranslation } from "react-i18next";

configure({
    ignoreTags: [],
});

const mapStateToProps = (state) => {
    return {
        path: state.navigator.path,
        search: state.explorer.search,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchMyFile: (keywords, path) => {
            dispatch(searchMyFile(keywords, path));
        },
    };
};

const styles = (theme) => ({
    search: {
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        "&:hover": {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(7.2),
            width: "auto",
        },
    },
    searchIcon: {
        width: theme.spacing(9),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    inputRoot: {
        color: "inherit",
        width: "100%",
    },
    inputInput: {
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(7),
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: 200,
            "&:focus": {
                width: 300,
            },
        },
    },
    suggestBox: {
        zIndex: "9999",
        width: 364,
    },
});

const keyMap = {
    SEARCH: "enter",
};

class SearchBarCompoment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            input: "",
        };
    }

    componentDidMount = () => {
        // 从 URL 同步分享搜索关键词到搜索框（支持直接打开 /search 链接）
        const keywords = new URLSearchParams(this.props.location.search).get(
            "keywords"
        );
        if (keywords !== null) {
            this.input = keywords;
            this.setState({ input: keywords });
        }
    };

    componentDidUpdate = (prevProps) => {
        const curKeywords = new URLSearchParams(this.props.location.search).get(
            "keywords"
        );
        const prevKeywords = new URLSearchParams(
            prevProps.location.search
        ).get("keywords");
        const curPath = this.props.location.pathname;
        const prevPath = prevProps.location.pathname;

        // 1. 分享搜索关键词变化时，同步进搜索框（直接打开 /search 链接或重新搜索）
        if (curKeywords !== prevKeywords) {
            if (curKeywords !== null) {
                this.input = curKeywords;
                this.setState({ input: curKeywords });
            }
            // keywords 变空时不在此处清空，交由下面的路由逻辑决定是否保留
        }

        // 2. 跳转到非搜索上下文页面（设置、我的分享等）时，清空搜索框原文本
        //    搜索上下文：首页（文件搜索）/ /search（分享搜索）
        const isSearchContext = (p) =>
            pathHelper.isHomePage(p) || p.startsWith("/search");
        if (curPath !== prevPath && !isSearchContext(curPath)) {
            this.input = "";
            this.setState({ input: "" });
        }
    };

    handlers = {
        SEARCH: (e) => {
            if (pathHelper.isHomePage(this.props.location.pathname)) {
                this.searchMyFile("")();
            } else {
                this.searchShare();
            }
            e.target.blur();
        },
    };

    handleChange = (event) => {
        const { currentTarget } = event;
        this.input = event.target.value;
        this.setState({
            anchorEl: currentTarget,
            input: event.target.value,
        });
    };

    handleFocus = (event) => {
        // 重新聚焦且已有内容时，重新展示建议浮层（不清除已输入文本）
        if (this.state.input !== "") {
            this.setState({
                anchorEl: event.currentTarget,
            });
        }
    };

    cancelSuggest = () => {
        // 仅关闭建议浮层，保留已输入的搜索文本
        this.setState({
            anchorEl: null,
        });
    };

    searchMyFile = (path) => () => {
        this.props.searchMyFile("keywords/" + this.input, path);
        // 在 /search 等搜索结果页点击“在文件中搜索”时，当前 FileManager 未挂载，
        // 需导航回首页才能真正展示文件搜索结果
        if (!pathHelper.isHomePage(this.props.location.pathname)) {
            this.props.history.push("/home");
        }
    };

    searchShare = () => {
        this.props.history.push(
            "/search?keywords=" + encodeURIComponent(this.input)
        );
    };

    render() {
        const { classes, t } = this.props;
        const { anchorEl } = this.state;
        const id = anchorEl !== null ? "simple-popper" : null;
        const isHomePage = pathHelper.isHomePage(this.props.location.pathname);

        return (
            <div className={classes.search}>
                <div className={classes.searchIcon}>
                    <SearchIcon />
                </div>
                <HotKeys keyMap={keyMap} handlers={this.handlers}>
                    <InputBase
                        placeholder={t("navbar.searchPlaceholder")}
                        classes={{
                            root: classes.inputRoot,
                            input: classes.inputInput,
                        }}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onBlur={this.cancelSuggest}
                        value={this.state.input}
                    />
                </HotKeys>
                <Popper
                    id={id}
                    open={anchorEl !== null}
                    anchorEl={anchorEl}
                    placement="bottom-start"
                    className={classes.suggestBox}
                    transition
                >
                    {({ TransitionProps }) => (
                        <Fade {...TransitionProps} timeout={350}>
                            <Paper
                                square={true}
                                style={{
                                    width:
                                        anchorEl && anchorEl.clientWidth
                                            ? anchorEl.clientWidth
                                            : undefined,
                                }}
                            >
                                {!pathHelper.isSharePage(
                                    this.props.location.pathname
                                ) && (
                                    <MenuItem onClick={this.searchMyFile("")}>
                                        <ListItemIcon className={classes.icon}>
                                            <FileIcon />
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{
                                                primary: classes.primary,
                                            }}
                                            primary={
                                                <Typography noWrap>
                                                    <Trans
                                                        i18nKey="navbar.searchInFiles"
                                                        values={{
                                                            name: this.state
                                                                .input,
                                                        }}
                                                        components={[
                                                            <strong key={0} />,
                                                        ]}
                                                    />
                                                </Typography>
                                            }
                                        />
                                    </MenuItem>
                                )}

                                {isHomePage &&
                                    this.props.path !== "/" &&
                                    !this.props.search && (
                                        <MenuItem
                                            onClick={this.searchMyFile(
                                                this.props.path
                                            )}
                                        >
                                            <ListItemIcon
                                                className={classes.icon}
                                            >
                                                <FolderIcon />
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{
                                                    primary: classes.primary,
                                                }}
                                                primary={
                                                    <Typography noWrap>
                                                        <Trans
                                                            i18nKey="navbar.searchInFolders"
                                                            values={{
                                                                name: this.state
                                                                    .input,
                                                            }}
                                                            components={[
                                                                <strong
                                                                    key={0}
                                                                />,
                                                            ]}
                                                        />
                                                    </Typography>
                                                }
                                            />
                                        </MenuItem>
                                    )}

                                <MenuItem onClick={this.searchShare}>
                                    <ListItemIcon className={classes.icon}>
                                        <ShareIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.primary }}
                                        primary={
                                            <Typography noWrap>
                                                <Trans
                                                    i18nKey="navbar.searchInShares"
                                                    values={{
                                                        name: this.state.input,
                                                    }}
                                                    components={[
                                                        <strong key={0} />,
                                                    ]}
                                                />
                                            </Typography>
                                        }
                                    />
                                </MenuItem>
                            </Paper>
                        </Fade>
                    )}
                </Popper>
            </div>
        );
    }
}

SearchBarCompoment.propTypes = {
    classes: PropTypes.object.isRequired,
};

const SearchBar = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(withTranslation()(SearchBarCompoment))));

export default SearchBar;
